import React, { useState, useEffect } from "react";
import { FaPlusCircle, FaTrashAlt } from "react-icons/fa";
import {
  Fetchexecutequery,
  Fetchheaderdata,
  Fetchupdatequery,
  Fetchfileupload,
  FetchsavePoRows,
} from "../../../services/process/BRS1/brsService7";
import axios from "axios";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import DynamicForm from "../common/DynamicForm";
import { CreateData } from "../../../services/process/process_data/process_data";
import { Icon } from "semantic-ui-react";
import { baseUrl } from "../../../services/common/credentials";
import FilePreviewer from "../common/file_displayer";


const baseUrl_1 = baseUrl+"1200"
/* ─────────────────────────── shared input style ─────────────────────────── */
const inp = {
  padding: "5px 8px",
  fontSize: 12,
  border: "1px solid #c8d0de",
  borderRadius: 4,
  width: "100%",
  boxSizing: "border-box",
  height: 30,
  background: "#fff",
  color: "#2d3a4a",
  outline: "none",
};

const readonlyInp = {
  ...inp,
  background: "#eef1f7",
  color: "#6b7a90",
  cursor: "default",
};

/* ─────────────────────────── card wrapper style ─────────────────────────── */
const card = {
  background: "#f8fafd",
  border: "1px solid #dce3ef",
  borderRadius: 8,
  padding: "14px 16px",
  marginBottom: 14,
};

const sectionTitle = {
  color: "#0a2352",
  fontSize: 13,
  fontWeight: 700,
  marginBottom: 10,
  letterSpacing: "0.04em",
  textTransform: "uppercase",
};

const colLabel = {
  fontSize: 10,
  fontWeight: 700,
  color: "#8a97b0",
  textTransform: "uppercase",
  letterSpacing: "0.05em",
};

export default function PdfConfigScreen() {
  /* ── PDF state ── */
  const [referencePdf, setReferencePdf] = useState(null);
  const [referencePdfUrl, setReferencePdfUrl] = useState(null);
  const [testPdf, setTestPdf] = useState(null);
  const [testPdfUrl, setTestPdfUrl] = useState(null);

  /* ── navigation state ── */
  const [activePdfView, setActivePdfView] = useState("reference"); // "reference" | "test"
  const [hasProcessed, setHasProcessed] = useState(false);

  /* ── auth / filter ── */
  const [userCredentials] = useState(
    JSON.parse(sessionStorage.getItem("userCredentials"))
  );
  const [filterconditions] = useState([
    {
      is_active: 1,
      entity_id: userCredentials.selectedentity,
      tenant_id: userCredentials.tenants_id,
      group_id: userCredentials.groups_id,
    },
  ]);

  /* ── field / table config ── */
  const [fields, setFields] = useState(null);
  const [columnDefs, setColumnDefs] = useState([]);
  const [tableData, settableData] = useState([]);
  const [tableHeaders, settableHeaders] = useState([]);
  const [formData, setFormData] = useState({});

  const [fieldsRows, setFieldsRows] = useState([
    { f1: "", t1: "", ref1: "", ext1: "" },
  ]);
  const [tableRows, setTableRows] = useState([{ name: "", type: "" }]);

  /* ── status ── */
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  /* ────────────────────────── init ────────────────────────── */
  useEffect(() => {
    fetchFieldInfo(86, setFields, setColumnDefs);
  }, []);

  const formatColumnName = (name) =>
    name
      .replace(/_/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());

  /* ────────────────────────── fetch header info ────────────────────────── */
  const fetchFieldInfo = async (
    headerConfigId,
    setFieldsFunc,
    setColumnDefsFunc
  ) => {
    const payload = {
      headerconfig_id: headerConfigId,
      filterconditions,
    };
    try {
      const creds = Fetchheaderdata();
      const { data } = await axios.post(creds[1], payload, creds[0]);
      if (data.fields?.length) {
        const columns = data.fields.map((f) => ({
          headerName: formatColumnName(f.columnName),
          field: f.columnName,
          sortable: true,
          filter: true,
          resizable: true,
        }));
        setColumnDefsFunc(columns);
        setFieldsFunc(data.fields);
        return { fields: data.fields };
      }
    } catch (e) {
      console.error("Error fetching field info:", e);
      setError("Error fetching fields data");
      return { fields: [] };
    }
  };

  /* ────────────────────────── file upload ────────────────────────── */
  const handleFileUpload = async (
    e,
    pdfType,
    file_path =
      "/home/demo/UserManagementModule/static/pdf"
  ) => {
    const file = e.target.files[0];
    if (!file) return;

    const uploadForm = new FormData();
    uploadForm.append("file", file);
    uploadForm.append("filePath", file_path);

    try {
      const res = await fetch(`${baseUrl_1}/api/v2/user_modules/upload/`, {
        method: "POST",
        body: uploadForm,
      });
      if (!res.ok) throw new Error("Upload failed");

      const data = await res.json();
      const backendFileName = data.Filename;

      /* store in formData */
      setFormData((prev) => ({
        ...prev,
        [`${pdfType}_pdf`]: { file_path, file_name: backendFileName },
      }));

      /* set preview states — FIX: was never set before */
      const previewUrl = `${baseUrl_1}/api/v2/user_modules/serve-pdf/${backendFileName}`;
      if (pdfType === "reference") {
        setReferencePdf(backendFileName);
        setReferencePdfUrl(previewUrl);
      } else if (pdfType === "test") {
        setTestPdf(backendFileName);
        setTestPdfUrl(previewUrl);
      }
    } catch (err) {
      console.error("Error uploading file:", err);
      alert("File upload failed");
    }
  };

  /* ────────────────────────── row helpers ────────────────────────── */
  const addFieldRow = () =>
    setFieldsRows([...fieldsRows, { f1: "", t1: "", ref1: "", ext1: "" }]);

  const deleteFieldRow = (index) => {
    if (fieldsRows.length === 1) return;
    setFieldsRows(fieldsRows.filter((_, i) => i !== index));
  };

  const addTableRow = () =>
    setTableRows([...tableRows, { name: "", type: "" }]);

  const deleteTableRow = (index) => {
    if (tableRows.length === 1) return;
    setTableRows(tableRows.filter((_, i) => i !== index));
  };

  /* ────────────────────────── submit ────────────────────────── */
  const handleSubmit = async () => {
    if (!formData.reference_pdf?.file_name) {
      alert("Reference PDF required");
      return;
    }

    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const submitForm = new FormData();
      submitForm.append("reference_pdf", formData.reference_pdf.file_name);
      if (formData.test_pdf?.file_name)
        submitForm.append("test_pdf", formData.test_pdf.file_name);

      submitForm.append("fields_rows", JSON.stringify(fieldsRows));
      submitForm.append("table_rows", JSON.stringify(tableRows));

      const derivedFields = fieldsRows
        .filter((r) => r.f1 && r.t1 && r.ref1)
        .map((r) => ({
          header: r.f1,
          value_type: r.t1,
          reference_value: r.ref1,
        }));
      if (derivedFields.length)
        submitForm.append("fields", JSON.stringify(derivedFields));

      const headers = tableRows.map((r) => r.name).filter(Boolean);
      if (headers.length)
        submitForm.append("headers", JSON.stringify(headers));

      const res = await fetch(
        `${baseUrl_1}/api/v2/user_modules/process-pdf/`,
        { method: "POST", body: submitForm }
      );
      const data = await res.json();

      if (!res.ok || !data.success) {
        setError(data.error || "Processing failed");
      } else {
        /* populate extracted values */
        if (data?.debug?.result?.fields?.length) {
          setFieldsRows((prev) =>
            prev.map((row, idx) => ({
              ...row,
              ext1: data.debug.result.fields[idx]?.extracted || "",
            }))
          );
        }

        /* FIX: was using stale `tableData` instead of `tableData_1` */
        const tableData_1 = data.table_fetched_result || [];
        const tableHeaders_1 =
          tableData_1.length > 0 ? Object.keys(tableData_1[0]) : [];

        settableData(tableData_1);
        settableHeaders(tableHeaders_1);
        setResult(data);

        /* navigation: start with reference PDF */
        setHasProcessed(true);
        setActivePdfView("reference");
      }
    } catch {
      setError("Network error");
    } finally {
      setLoading(false);
    }
  };

  /* ────────────────────────── derived ────────────────────────── */
  const currentPdfUrl =
    activePdfView === "reference" ? referencePdfUrl : testPdfUrl;

  /* ────────────────────────── render ────────────────────────── */
  return (
    <div style={{ padding: 16, fontFamily: "'Segoe UI', sans-serif" }}>
      {/* ── Page title ── */}
      <h2
        style={{
          color: "#0a2352",
          fontSize: 18,
          textAlign: "center",
          marginBottom: 16,
          fontWeight: 700,
          letterSpacing: "0.04em",
        }}
      >
        PDF CONFIG SCREEN
      </h2>

      <div style={{ display: "flex", gap: 18, alignItems: "flex-start" }}>
        {/* ══════════════════ LEFT PANEL ══════════════════ */}
        <div style={{ flex: 1, minWidth: 0 }}>
          {/* Upload card */}
          <div style={card}>
            <p style={sectionTitle}>Upload PDFs</p>
            <div style={{ display: "flex", gap: 16 }}>
              {/* Reference */}
              <div style={{ flex: 1 }}>
                <label
                  style={{
                    display: "block",
                    fontSize: 11,
                    fontWeight: 700,
                    color: "#444",
                    marginBottom: 5,
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                  }}
                >
                  Reference PDF
                </label>
                <input
                  type="file"
                  accept="application/pdf"
                  onChange={(e) => handleFileUpload(e, "reference")}
                  style={{ fontSize: 12, width: "100%" }}
                />
                {referencePdf && (
                  <span
                    style={{
                      fontSize: 11,
                      color: "#2e7d32",
                      marginTop: 4,
                      display: "block",
                    }}
                  >
                    ✓ {referencePdf}
                  </span>
                )}
              </div>

              {/* Test */}
              <div style={{ flex: 1 }}>
                <label
                  style={{
                    display: "block",
                    fontSize: 11,
                    fontWeight: 700,
                    color: "#444",
                    marginBottom: 5,
                    textTransform: "uppercase",
                    letterSpacing: "0.05em",
                  }}
                >
                  Test PDF
                </label>
                <input
                  type="file"
                  accept="application/pdf"
                  onChange={(e) => handleFileUpload(e, "test")}
                  style={{ fontSize: 12, width: "100%" }}
                />
                {testPdf && (
                  <span
                    style={{
                      fontSize: 11,
                      color: "#2e7d32",
                      marginTop: 4,
                      display: "block",
                    }}
                  >
                    ✓ {testPdf}
                  </span>
                )}
              </div>
            </div>
          </div>

          {/* ── PDF viewer ── */}
          {(hasProcessed || referencePdf) && (
            <div
              style={{
                border: "1px solid #dce3ef",
                borderRadius: 8,
                overflow: "hidden",
              }}
            >
              {/* Navigation tabs — shown only after processing */}
              {hasProcessed ? (
                <div style={{ display: "flex" }}>
                  {[
                    { key: "reference", label: "← Reference PDF" },
                    { key: "test", label: "Test PDF →" },
                  ].map(({ key, label }) => {
                    const isActive = activePdfView === key;
                    const isDisabled = key === "test" && !testPdfUrl;
                    return (
                      <button
                        key={key}
                        onClick={() => !isDisabled && setActivePdfView(key)}
                        style={{
                          flex: 1,
                          padding: "10px 0",
                          fontSize: 12,
                          fontWeight: isActive ? 700 : 500,
                          background: isActive ? "#0a2352" : "#eef1f7",
                          color: isActive
                            ? "#fff"
                            : isDisabled
                            ? "#b0bac8"
                            : "#0a2352",
                          border: "none",
                          borderBottom: isActive
                            ? "none"
                            : "1px solid #dce3ef",
                          borderRight:
                            key === "reference"
                              ? "1px solid #dce3ef"
                              : "none",
                          cursor: isDisabled ? "not-allowed" : "pointer",
                          letterSpacing: "0.03em",
                          transition: "all 0.18s",
                        }}
                      >
                        {label}
                        {isDisabled && (
                          <span
                            style={{ fontSize: 10, marginLeft: 5, opacity: 0.7 }}
                          >
                            (not uploaded)
                          </span>
                        )}
                      </button>
                    );
                  })}
                </div>
              ) : (
                /* Before processing — just show "Reference PDF Preview" header */
                <div
                  style={{
                    padding: "9px 14px",
                    background: "#0a2352",
                    color: "#fff",
                    fontSize: 12,
                    fontWeight: 700,
                    letterSpacing: "0.04em",
                    textTransform: "uppercase",
                  }}
                >
                  Reference PDF Preview
                </div>
              )}

              {/* Viewer */}
              <div style={{ height: 560 }}>
                {(hasProcessed ? currentPdfUrl : referencePdfUrl) ? (
                  <FilePreviewer
                    fileType="pdf"
                    fileUrl={hasProcessed ? currentPdfUrl : referencePdfUrl}
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "100%",
                      color: "#aab",
                      fontSize: 13,
                    }}
                  >
                    No PDF to display
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* ══════════════════ RIGHT PANEL ══════════════════ */}
        <div style={{ flex: 1, minWidth: 0 }}>
          {/* ─── Fields card ─── */}
          <div style={card}>
            <p style={sectionTitle}>Fields</p>

            {/* column labels */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1.8fr 0.8fr 1.5fr 1.5fr 28px",
                gap: 6,
                marginBottom: 5,
              }}
            >
              {[
                "Field Name",
                "Type",
                "Reference Value",
                "Extracted Value",
                "",
              ].map((h, i) => (
                <span key={i} style={colLabel}>
                  {h}
                </span>
              ))}
            </div>

            {/* rows — all on one line via CSS grid */}
            {fieldsRows.map((row, i) => (
              <div
                key={i}
                style={{
                  display: "grid",
                  gridTemplateColumns: "1.8fr 0.8fr 1.5fr 1.5fr 28px",
                  gap: 6,
                  marginBottom: 6,
                  alignItems: "center",
                }}
              >
                <input
                  value={row.f1}
                  placeholder="Field name"
                  onChange={(e) =>
                    updateRow(setFieldsRows, fieldsRows, i, "f1", e.target.value)
                  }
                  style={inp}
                />
                <select
                  value={row.t1}
                  onChange={(e) =>
                    updateRow(setFieldsRows, fieldsRows, i, "t1", e.target.value)
                  }
                  style={inp}
                >
                  <option value="">Type</option>
                  <option value="text">Text</option>
                  <option value="int">Int</option>
                  <option value="decimal">Decimal</option>
                  <option value="date">Date</option>
                </select>
                <input
                  value={row.ref1}
                  placeholder="Reference value"
                  onChange={(e) =>
                    updateRow(setFieldsRows, fieldsRows, i, "ref1", e.target.value)
                  }
                  style={inp}
                />
                <input
                  value={row.ext1 || ""}
                  readOnly
                  placeholder="—"
                  style={readonlyInp}
                />
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <FaTrashAlt
                    style={{ cursor: "pointer", color: "#c00", fontSize: 13 }}
                    onClick={() => deleteFieldRow(i)}
                  />
                </div>
              </div>
            ))}

            <FaPlusCircle
              size={18}
              style={{ cursor: "pointer", color: "#007bff", marginTop: 4 }}
              onClick={addFieldRow}
              title="Add field row"
            />
          </div>

          {/* ─── Table card ─── */}
          <div style={card}>
            <p style={sectionTitle}>Table Columns</p>

            {/* column labels */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "2fr 1fr 28px",
                gap: 6,
                marginBottom: 5,
              }}
            >
              {["Column Name", "Type", ""].map((h, i) => (
                <span key={i} style={colLabel}>
                  {h}
                </span>
              ))}
            </div>

            {tableRows.map((row, index) => (
              <div
                key={index}
                style={{
                  display: "grid",
                  gridTemplateColumns: "2fr 1fr 28px",
                  gap: 6,
                  marginBottom: 6,
                  alignItems: "center",
                }}
              >
                <input
                  placeholder="Column name"
                  value={row.name}
                  onChange={(e) => {
                    const updated = [...tableRows];
                    updated[index].name = e.target.value;
                    setTableRows(updated);
                  }}
                  style={inp}
                />
                <select
                  value={row.type}
                  onChange={(e) => {
                    const updated = [...tableRows];
                    updated[index].type = e.target.value;
                    setTableRows(updated);
                  }}
                  style={inp}
                >
                  <option value="">Type</option>
                  <option value="text">Text</option>
                  <option value="int">Int</option>
                  <option value="decimal">Decimal</option>
                  <option value="date">Date</option>
                </select>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <FaTrashAlt
                    style={{ cursor: "pointer", color: "#c00", fontSize: 13 }}
                    onClick={() => deleteTableRow(index)}
                  />
                </div>
              </div>
            ))}

            <FaPlusCircle
              size={18}
              style={{ cursor: "pointer", color: "#007bff", marginTop: 4 }}
              onClick={addTableRow}
              title="Add table column"
            />
          </div>

          {/* ─── Submit button — same style as PO Mapping ─── */}
          <div className="submit-row">
            <button
              type="submit"
              className="submit-btn"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Processing..." : "Process PDF"}
            </button>
          </div>

          {/* ─── Error banner ─── */}
          {error && (
            <div
              style={{
                marginTop: 10,
                padding: "8px 14px",
                background: "#ffebee",
                border: "1px solid #ef9a9a",
                borderRadius: 6,
                color: "#c00",
                fontSize: 12,
              }}
            >
              ⚠ {error}
            </div>
          )}

          {/* ─── Extracted table results ─── */}
          {tableData.length > 0 && (
            <div
              style={{
                marginTop: 14,
                border: "1px solid #dce3ef",
                borderRadius: 8,
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  padding: "9px 14px",
                  background: "#0a2352",
                  color: "#fff",
                  fontSize: 12,
                  fontWeight: 700,
                  letterSpacing: "0.04em",
                  textTransform: "uppercase",
                }}
              >
                Extracted Table Data
              </div>
              <div style={{ overflowX: "auto" }}>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    fontSize: 12,
                  }}
                >
                  <thead>
                    <tr style={{ background: "#e8ecf5" }}>
                      {tableHeaders.map((h) => (
                        <th
                          key={h}
                          style={{
                            padding: "8px 10px",
                            textAlign: "left",
                            borderBottom: "1px solid #dce3ef",
                            color: "#0a2352",
                            fontWeight: 700,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {formatColumnName(h)}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {tableData.map((row, ri) => (
                      <tr
                        key={ri}
                        style={{
                          background: ri % 2 === 0 ? "#fff" : "#f7f9fd",
                        }}
                      >
                        {tableHeaders.map((h) => (
                          <td
                            key={h}
                            style={{
                              padding: "7px 10px",
                              borderBottom: "1px solid #f0f2f7",
                              color: "#333",
                            }}
                          >
                            {row[h] ?? "—"}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {result && tableData.length === 0 && (
            <div
              style={{
                marginTop: 10,
                padding: "8px 14px",
                background: "#e8f5e9",
                border: "1px solid #a5d6a7",
                borderRadius: 6,
                color: "#2e7d32",
                fontSize: 12,
              }}
            >
              ✓ Processing complete. No table data extracted.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

/* ─────────────────────────── helper ─────────────────────────── */
function updateRow(setter, rows, index, key, value) {
  const updated = [...rows];
  updated[index][key] = value;
  setter(updated);
}